var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 692,
    viewBox: "0 0 1440 692",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25987_49625)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25987_49625",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 692
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440 692H0V0H1440V692Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25987_49625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M653.142 152.024C665.763 127.463 695.906 117.785 720.467 130.406L1998.45 787.148C2023.01 799.77 2032.69 829.912 2020.06 854.473L1546.48 1776.03C1533.86 1800.59 1503.92 1810.37 1479.37 1797.75C1365.5 1739.27 1056.31 1580.44 840.651 1469.51C625.493 1358.84 315.164 1199.43 201.008 1140.79C176.441 1128.17 166.949 1098.13 179.572 1073.56L653.142 152.024Z",
    fill: "#BCDDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.142 145.024C285.763 120.463 315.906 110.785 340.467 123.406L1618.45 780.148C1643.01 792.77 1652.69 822.912 1640.06 847.473L1166.48 1769.03C1153.86 1793.59 1123.92 1803.37 1099.37 1790.75C985.504 1732.27 676.311 1573.44 460.651 1462.51C245.493 1351.84 -64.836 1192.43 -178.992 1133.79C-203.559 1121.17 -213.051 1091.13 -200.428 1066.56L273.142 145.024Z",
    fill: "#BCDDFF",
    fillOpacity: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25987_49625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 692,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg2);
export default __webpack_public_path__ + "static/media/bg-2.f258047ba87bd218479e848831db85d6.svg";
export { ForwardRef as ReactComponent };